import styled from "styled-components";
import { Tag } from "antd";
import { greyText, lightGreys } from "../../../styles";

/**
 * A styled tag component for displaying labels, categories, or metadata
 * Uses grey background with no border for a subtle appearance
 */
export const ModalTag = styled(Tag)`
  background: ${lightGreys.KPIBackground};
  border: none;
  color: ${greyText};
  font-size: 12px;
  padding: 2px 8px;
  margin: 0;
`;

/**
 * Tag container for wrapping multiple tags
 */
export const ModalTagGroup = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;
